import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import Popover from "@v1/components/designSystem/popover/Popover";
import { selectDoesExistDraftElement } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";
import { ConnectShopifyCallout } from "@v2/components/ConnectShopifyCallout";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";

export const PublishPageButtonWithCallout: React.FC = () => {
  const draftElementExists = useEditorSelector(selectDoesExistDraftElement);
  const projectId = useCurrentProjectId();
  const workspaceId = useCurrentWorkspaceId();

  return (
    <Popover
      shouldPreventDefaultOnInteractOutside={false}
      content={
        <ConnectShopifyCallout
          cookieValue={{
            type: "publish",
            projectId: projectId!,
            workspaceId: workspaceId!,
          }}
        />
      }
      side="bottom"
      align="end"
      sideOffset={16}
      triggerAsChild
      hideCloseButton
      className="w-72"
    >
      <DeprecatedButton
        variant="primary"
        size="base"
        disabled={!draftElementExists}
      >
        Publish
      </DeprecatedButton>
    </Popover>
  );
};
